<template>
  <span>
         <img :src="imgPath" class="iconBtn transition"
              @click="emitEvent({method: 'addNew'})"
              v-tippy="{ placement : 'top'}"
              v-if="!options.type || options.type === 'single'"
              :title="(options.title)? options.title : 'הוסף חדש'">
             <img :src="imgPath" class="iconBtn transition"
                  @click="filterToggle = true"
                  id="toolbarAddIcon"
                  v-tippy="{ placement : 'top'}"
                  v-if="options.type && options.type === 'list'"
                  :title="'הוסף חדש'">

        <div class="filterMenu" v-menufocus:opt="{class: 'filterMenu', trigger: 'filterToggle', el: 'toolbarAddIcon'}" v-if="filterToggle === true">
          <div class="checkbox" v-for="(item, i) in options.items"
               @click="emitEvent({method: item.value, data: item.value})">
            {{item.label}}
          </div>
        </div>
  </span>
</template>

<script>
  export default {
    name: 'AddNewElement',
    props: ['options'],
    data () {
      return {
        filterToggle: false,
        imgPath: ''
      }
    },
    created () {
    },
    mounted(){
      if(this.options.icon){
        this.imgPath = this.options.icon
      }else{
        this.imgPath = "/clientV2/static/gfx/newPlus.svg"
      }
    },
    methods: {
      emitEvent: function (data) {
        this.$emit('emit', data)
      }
    },
    watch: {
      options: function () {
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/style.less";

  .filterMenu {
    div {
      cursor: pointer;
      transition: all .3s;
      &:hover {
        background: #fefefe;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toolbar/AddNewElement.vue